import React, { useState } from 'react'
import st from './EmployeeList.module.scss'
import { ReactComponent as OpenClient } from 'components/CRM/UI/icons/arrow-down-s-line.svg'
import CardDeal from '../CardDeal/CardDeal'
import useLocalization from 'hooks/useLocalization'

const EmployeeList = ({ client, index }) => {
  const [expanded, setExpanded] = useState(false)

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      new: 'New',
      in_work: 'In work',
      successful: 'Successful',
      quantity: 'Quantity',
      sum: 'Sum',
    },
  })

  return (
    <>
      <div
        className={`${st.flexRow} ${index % 2 === 0 ? st.colorBg : null} ${expanded && st.colorBgActive}`}
      >
        <div className={`${st.flexColumn} ${st.firstColumn}`}>
          {client.full_name}
        </div>
        <div className={`${st.flexColumn} ${st.element}`}>
          {Object.keys(client?.active_deals).length === 0 ||
          client?.active_deals?.deal_count === null
            ? 0 + ' '
            : client?.active_deals?.deal_count?.toLocaleString('ru-RU') + ' '}
          (
          {Object.keys(client?.active_deals).length === 0 ||
          client?.active_deals?.budget === null
            ? 0
            : client?.active_deals?.budget?.toLocaleString('ru-RU')}
          ₸)
        </div>
        <div className={`${st.flexColumn} ${st.element}`}>
          {Object.keys(client?.won_deals).length === 0 ||
          client?.won_deals?.deal_count === null
            ? 0 + ' '
            : client?.won_deals?.deal_count?.toLocaleString('ru-RU') + ' '}
          (
          {Object.keys(client?.won_deals).length === 0 ||
          client?.won_deals?.budget === 0
            ? null
            : client?.won_deals?.budget?.toLocaleString('ru-RU')}
          ₸)
        </div>
        <div className={`${st.flexColumn} ${st.element}`} />
        <div
          className={`${st.lastColumn} ${index % 2 === 0 ? st.colorBg : null} ${expanded && st.colorBgActive}`}
        >
          <div
            className={`${st.buttonClient} ${expanded ? st.rotate : ''}`}
            onClick={toggleExpand}
          >
            <OpenClient className={st.btnArrow} />
          </div>
        </div>
      </div>
      {expanded && (
        <div className={st.clientDetails}>
          <CardDeal
            translate={translate}
            name={translate.new}
            deal_status={client?.new_deals}
            styleClass={st.newDealsColor}
            colorText={st.whiteText}
            colorInf={st.whiteText}
          />
          <CardDeal
            translate={translate}
            name={translate.in_work}
            deal_status={client?.active_deals}
            styleClass={st.activeDealsColor}
            colorText={st.greyText}
            colorInf={st.blueText}
          />
          <CardDeal
            translate={translate}
            name={translate.successful}
            deal_status={client?.won_deals}
            styleClass={st.wonDealsColor}
            colorText={st.whiteText}
            colorInf={st.whiteText}
          />
        </div>
      )}
    </>
  )
}
export default EmployeeList
